import authApi from 'utils/authApi';

export const updateProfile = (data) => {
    return authApi.post(`/update-profile`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const getProfile = (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await authApi.get(`/users/${id}`);
            resolve(response.data);
        } catch (err) {
            reject(err);
        }
    });
};

export const changePassword = (data) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await authApi.post('/change-password', data);
            resolve(response.data);
        } catch (err) {
            reject(err);
        }
    });
};
